<template>
  <div class="d-flex flex-nowrap">
    <action-button
      class="mx-2"
      color="error"
      :small="!large"
      :disabled="disabled"
      @click="$emit('vote', 'NO')"
    >
      <v-icon class="material-icons-outlined" small>
        {{ noIcon }}
      </v-icon>
      <span v-if="showLabels" class="ml-1">{{ noLabel }}</span>
    </action-button>
    <action-button
      v-if="!hideNotSure && !fullTextReview"
      class="mx-2"
      color="warning"
      :small="!large"
      :disabled="disabled"
      @click="$emit('vote', 'NOT_SURE')"
    >
      <v-icon class="material-icons-outlined" small>
        {{ notSureIcon }}
      </v-icon>
      <span v-if="showLabels" class="ml-1">Not Sure</span>
    </action-button>
    <action-button
      class="mx-2"
      color="success"
      :disabled="disabled"
      :small="!large"
      @click="$emit('vote', 'YES')"
    >
      <v-icon class="material-icons-outlined" small>
        {{ yesIcon }}
      </v-icon>
      <span v-if="showLabels" class="ml-1">{{ yesLabel }}</span>
    </action-button>
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
export default {
  name: 'VoteControls',
  components: {
    ActionButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hideNotSure: {
      type: Boolean,
      default: false,
    },
    useSingleActionIcons: {
      type: Boolean,
      default: false,
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    fullTextReview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    noIcon() {
      return this.useSingleActionIcons ? 'close' : 'thumb_down_alt';
    },
    notSureIcon() {
      return this.useSingleActionIcons ? 'help' : 'help_outline';
    },
    yesIcon() {
      return this.useSingleActionIcons ? 'check' : 'thumb_up_alt';
    },
    noLabel() {
      return this.fullTextReview ? 'Exclude' : 'Not Relevant';
    },
    yesLabel() {
      return this.fullTextReview ? 'Include' : 'Relevant';
    },
  },
};
</script>
